(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bathwise-footer"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-bw-cookie-preferences]');
    if (!trigger) return;
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-main-product-rollback-20261002"]) return;
  try {
    
  (() => {
    const initialiseProductGalleries = (scope = document) => {
      scope.querySelectorAll('[data-bw-product-gallery]').forEach((gallery) => {
        if (gallery.dataset.bwGalleryReady === 'true') return;
        gallery.dataset.bwGalleryReady = 'true';

        const panels = [...gallery.querySelectorAll('[data-bw-gallery-panel]')];
        const thumbnails = [...gallery.querySelectorAll('[data-bw-gallery-thumbnail]')];
        const page = gallery.closest('.bw-product-page');
        const variantSelect = page?.querySelector('[data-bw-variant-select]');

        const activateMedia = (mediaId) => {
          const target = panels.find((panel) => panel.dataset.mediaId === mediaId);
          if (!target) return false;

          panels.forEach((panel) => {
            const isActive = panel === target;
            panel.hidden = !isActive;
            panel.classList.toggle('is-active', isActive);

            if (!isActive) {
              panel.querySelectorAll('video').forEach((video) => video.pause());
            }
          });

          thumbnails.forEach((thumbnail) => {
            const isActive = thumbnail.dataset.mediaId === mediaId;
            thumbnail.classList.toggle('is-active', isActive);
            thumbnail.setAttribute('aria-pressed', String(isActive));
            if (isActive) {
              const strip = thumbnail.parentElement;
              const targetLeft = thumbnail.offsetLeft - ((strip.clientWidth - thumbnail.clientWidth) / 2);
              strip.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
            }
          });

          return true;
        };

        thumbnails.forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => activateMedia(thumbnail.dataset.mediaId));
        });

        if (variantSelect) {
          variantSelect.addEventListener('change', () => {
            const option = variantSelect.options[variantSelect.selectedIndex];
            if (!option) return;
            const application = page.querySelector('[data-bw-product-application]');
            if (application) application.textContent = option.dataset.tileType === 'Wall tile' ? 'Walls only' : option.dataset.tileType === 'Wall and floor tile' ? 'Walls and floors' : 'Suitability to be confirmed';

            let matched = option.dataset.mediaId && activateMedia(option.dataset.mediaId);

            if (!matched && option.dataset.sku) {
              const skuMatch = panels.find((panel) => panel.dataset.imageKeywords?.includes(option.dataset.sku));
              if (skuMatch) matched = activateMedia(skuMatch.dataset.mediaId);
            }

            if (!matched && option.dataset.variantTitle) {
              const optionParts = option.dataset.variantTitle.split('/').map((part) => part.trim()).filter(Boolean).reverse();
              const titleMatch = panels.find((panel) => optionParts.some((part) => panel.dataset.imageKeywords?.includes(part)));
              if (titleMatch) activateMedia(titleMatch.dataset.mediaId);
            }

            const url = new URL(window.location.href);
            url.searchParams.set('variant', option.value);
            window.history.replaceState({}, '', url);
          });
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseProductGalleries());
    } else {
      initialiseProductGalleries();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseProductGalleries(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const initialiseProductGalleries = (scope = document) => {
      scope.querySelectorAll('[data-bw-product-gallery]').forEach((gallery) => {
        if (gallery.dataset.bwGalleryReady === 'true') return;
        gallery.dataset.bwGalleryReady = 'true';

        const panels = [...gallery.querySelectorAll('[data-bw-gallery-panel]')];
        const thumbnails = [...gallery.querySelectorAll('[data-bw-gallery-thumbnail]')];
        const page = gallery.closest('.bw-product-page');
        const variantSelect = page?.querySelector('[data-bw-variant-select]');

        const activateMedia = (mediaId) => {
          const target = panels.find((panel) => panel.dataset.mediaId === mediaId);
          if (!target) return false;

          panels.forEach((panel) => {
            const isActive = panel === target;
            panel.hidden = !isActive;
            panel.classList.toggle('is-active', isActive);

            if (!isActive) {
              panel.querySelectorAll('video').forEach((video) => video.pause());
            }
          });

          thumbnails.forEach((thumbnail) => {
            const isActive = thumbnail.dataset.mediaId === mediaId;
            thumbnail.classList.toggle('is-active', isActive);
            thumbnail.setAttribute('aria-pressed', String(isActive));
            if (isActive) {
              const strip = thumbnail.parentElement;
              const targetLeft = thumbnail.offsetLeft - ((strip.clientWidth - thumbnail.clientWidth) / 2);
              strip.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
            }
          });

          return true;
        };

        thumbnails.forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => activateMedia(thumbnail.dataset.mediaId));
        });

        if (variantSelect) {
          variantSelect.addEventListener('change', () => {
            const option = variantSelect.options[variantSelect.selectedIndex];
            if (!option) return;
            const application = page.querySelector('[data-bw-product-application]');
            if (application) application.textContent = option.dataset.tileType === 'Wall tile' ? 'Walls only' : option.dataset.tileType === 'Wall and floor tile' ? 'Walls and floors' : 'Suitability to be confirmed';

            let matched = option.dataset.mediaId && activateMedia(option.dataset.mediaId);

            if (!matched && option.dataset.sku) {
              const skuMatch = panels.find((panel) => panel.dataset.imageKeywords?.includes(option.dataset.sku));
              if (skuMatch) matched = activateMedia(skuMatch.dataset.mediaId);
            }

            if (!matched && option.dataset.variantTitle) {
              const optionParts = option.dataset.variantTitle.split('/').map((part) => part.trim()).filter(Boolean).reverse();
              const titleMatch = panels.find((panel) => optionParts.some((part) => panel.dataset.imageKeywords?.includes(part)));
              if (titleMatch) activateMedia(titleMatch.dataset.mediaId);
            }

            const url = new URL(window.location.href);
            url.searchParams.set('variant', option.value);
            window.history.replaceState({}, '', url);
          });
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseProductGalleries());
    } else {
      initialiseProductGalleries();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseProductGalleries(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  if (!customElements.get('bathwise-predictive-search')) {
    class BathwisePredictiveSearch extends HTMLElement {
      constructor() {
        super();
        this.cache = new Map();
        this.timer = null;
        this.controller = null;
        this.activeTerm = '';
        this.handleInput = this.handleInput.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleDocumentPointer = this.handleDocumentPointer.bind(this);
        this.handleFocusOut = this.handleFocusOut.bind(this);
      }

      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;
        this.input = this.querySelector('[data-bw-predictive-input]');
        this.results = this.querySelector('[data-bw-predictive-results]');
        if (!this.input || !this.results) return;
        this.minimumCharacters = Number(this.dataset.minCharacters || 2);
        this.input.addEventListener('input', this.handleInput);
        this.input.addEventListener('focus', this.handleFocus);
        this.addEventListener('keydown', this.handleKeydown);
        this.addEventListener('focusout', this.handleFocusOut);
        document.addEventListener('pointerdown', this.handleDocumentPointer);
      }

      disconnectedCallback() {
        if (!this.input || !this.results) return;
        this.input.removeEventListener('input', this.handleInput);
        this.input.removeEventListener('focus', this.handleFocus);
        this.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('focusout', this.handleFocusOut);
        document.removeEventListener('pointerdown', this.handleDocumentPointer);
        if (this.controller) this.controller.abort();
        window.clearTimeout(this.timer);
      }

      handleInput() {
        const term = this.input.value.trim();
        this.activeTerm = term;
        window.clearTimeout(this.timer);
        if (this.controller) this.controller.abort();

        if (term.length < this.minimumCharacters) {
          this.results.replaceChildren();
          this.close();
          return;
        }

        this.showMessage(this.dataset.loadingText || 'Searching…');
        this.results.setAttribute('aria-busy', 'true');
        this.timer = window.setTimeout(() => this.fetchResults(term), 220);
      }

      handleFocus() {
        const term = this.input.value.trim();
        if (term.length < this.minimumCharacters) return;
        if (this.results.childElementCount > 0) {
          this.open();
        } else {
          this.handleInput();
        }
      }

      handleKeydown(event) {
        if (event.key === 'Escape') {
          this.close();
          this.input.focus();
          return;
        }

        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        const options = Array.from(this.results.querySelectorAll('[data-bw-predictive-option]'));
        if (options.length === 0) return;
        event.preventDefault();
        const currentIndex = options.indexOf(document.activeElement);
        let nextIndex;
        if (event.key === 'ArrowDown') {
          nextIndex = currentIndex < 0 ? 0 : (currentIndex + 1) % options.length;
        } else {
          nextIndex = currentIndex < 0 ? options.length - 1 : (currentIndex - 1 + options.length) % options.length;
        }
        options[nextIndex].focus();
      }

      handleDocumentPointer(event) {
        if (!this.contains(event.target)) this.close();
      }

      handleFocusOut() {
        window.setTimeout(() => {
          if (!this.contains(document.activeElement)) this.close();
        }, 0);
      }

      async fetchResults(term) {
        const cacheKey = term.toLowerCase();
        if (this.cache.has(cacheKey)) {
          if (this.activeTerm === term) this.render(this.cache.get(cacheKey));
          return;
        }

        this.controller = new AbortController();
        const url = new URL(this.dataset.predictiveUrl, window.location.origin);
        url.searchParams.set('q', term);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '10');
        url.searchParams.set('resources[limit_scope]', 'each');
        url.searchParams.set('resources[options][unavailable_products]', 'show');
        url.searchParams.set('resources[options][prefix]', 'last');
        url.searchParams.set('resources[options][fields]', 'title,product_type,vendor,tag,variants.title,variants.sku');
        url.searchParams.set('section_id', 'bathwise-predictive-search');

        try {
          const response = await fetch(url, {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: this.controller.signal
          });
          const text = await response.text();
          if (!response.ok) throw new Error(`${response.status}: ${text}`);
          const documentFragment = new DOMParser().parseFromString(text, 'text/html');
          const section = documentFragment.querySelector('#shopify-section-bathwise-predictive-search');
          if (!section) throw new Error('Predictive search section was not returned.');
          const markup = section.innerHTML.trim();
          this.cache.set(cacheKey, markup);
          if (this.activeTerm === term) this.render(markup);
        } catch (error) {
          if (error.name !== 'AbortError' && this.activeTerm === term) {
            this.showMessage(this.dataset.errorText || 'Suggestions are temporarily unavailable.');
          }
        } finally {
          if (this.activeTerm === term) this.results.setAttribute('aria-busy', 'false');
        }
      }

      render(markup) {
        this.results.innerHTML = markup;
        this.results.setAttribute('aria-busy', 'false');
        this.open();
      }

      showMessage(message) {
        const status = document.createElement('p');
        status.className = 'bw-predictive__status';
        status.textContent = message;
        this.results.replaceChildren(status);
        this.open();
      }

      open() {
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.results.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
      }
    }

    customElements.define('bathwise-predictive-search', BathwisePredictiveSearch);
  }

  } catch(e) { console.error(e); }
})();
})();
